import { EditDeviationComponent } from '../deviation/components/deviation-edit/deviation-edit.component';
import {
  DepartmentForAdminResolver,
  DeviationEditResolver
} from '../deviation/services/deviation.resolver';
import {
  BusinessCacheResolver,
  CompanyNameResolver,
  CompanyNameFastResolver,
  RiskListResolver
} from './../businesses/services/business.resolver.service';
import { EmployeeDocResolver } from './../employees/services/employee.resolver.service';

import { AddDeviationComponent } from './components/deviation-new.component';

import { EmployeeContactUserResolver } from './../users/services/user.resolver.service';
import { PortalActivityNewComponent } from './components/portal-activity-new.component';
import {
  AllDepartmentCachedResolver,
  AllDepartmentResolver,
  DepartmentsByBusinessIdResolver,
  BusinessLevelTopicResolver,
  ClientResolver,
  DeviationsByUserResolver,
  DeviationUserResolver,
  EmployeeContactsListResolver,
  FollowupCaseTypeByBusinessIdResolver,
  FollowupCaseTypeResolver,
  FollowupDeviationListResolver,
  FollowupTopicResolver,
  ResponsibleForExecutionResolver,
  ModuleObjectDropdownResolver
} from './services/deviation.resolver.service';
import {
  ApprovalNoticesResolver,
  FollowupDepartmentForAdminResolver,
  RiskAnalysisAdminResolver,
  RiskAnalysisCategoryResolver,
  RiskAnalysisEditResolver,
  RiskAnalysisListResolver,
  RiskAnalysisLogResolver,
  RiskAnalysisTopicCachedResolver,
  RiskAnalysisTopicForAdminResolver,
  UserForAdminResolver
} from './services/risk-analysis.resolver.service';

import { AuthGuard } from './../../_guards/auth.guard';
import { ActivityListComponent } from './components/activity-list.component';
import {
  ActivityEditResolver,
  ChecklistResolver,
  DepartmentCachedListResolver,
  RepetionListResolver,
  PortalActivityEditResolver,
  PortalActivityDepartmentsResolver,
  PortalActivityUsersResolver,
  PortalActivityChecklistResolver
} from './services/activities.resolver.service';

import { Route } from '@angular/router';

import {
  DeviationListComponent,
  EditActivitiesComponent,
  FollowUpActivitiesComponent,
  FollowUpDeviationComponent,
  NewRiskAnalysisComponent,
  NewRiskPortalComponent,
  RiskAnalysisComponent,
  RiskAnalysisListComponent
} from './components/index';
import { FollowUpsComponent } from './followups.component';

import { ArchiveTreeDataResolver } from '../archive/archive.resolver.service';
import { SjaListComponent } from '../sja-form/components/sja-list.component';
import { SjaUserformComponent } from '../sja-form/components/sja-userform.component';
import { SjaFormComponent } from '../sja-form/sja-form.component';
import {
  SJAFormListResolver,
  SJAFormResolver,
  SJATitleListResolver
} from '../sja-form/sjaform.resolver.service';

export const followupRoutes: Route[] = [
  {
    path: 'follow-up',
    component: FollowUpsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'activities',
        component: FollowUpActivitiesComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ActivityListComponent,
            data: { skipAdminPreloads: true },
            resolve: {
              repetition: RepetionListResolver,
              user: EmployeeContactUserResolver,

              business: CompanyNameFastResolver,
              departments: AllDepartmentResolver
            },
            canActivate: [AuthGuard]
          },
          {
            path: 'edit/:aid',
            component: EditActivitiesComponent,
            resolve: {
              detail: ActivityEditResolver,
              departments: DepartmentCachedListResolver,
              repetition: RepetionListResolver,
              Checklist: ChecklistResolver,
              user: EmployeeContactUserResolver
            },
            canActivate: [AuthGuard]
          },
          {
            path: 'portal-activity-new',
            component: PortalActivityNewComponent,
            resolve: {
              repetition: RepetionListResolver
            },
            canActivate: [AuthGuard]
          },
          {
            path: 'portal-edit/:aid',
            component: EditActivitiesComponent,
            resolve: {
              detail: PortalActivityEditResolver,
              departments: PortalActivityDepartmentsResolver,
              repetition: RepetionListResolver,
              Checklist: PortalActivityChecklistResolver,
              user: PortalActivityUsersResolver
            },
            canActivate: [AuthGuard]
          }
        ]
      },

      {
        path: 'deviations',
        component: FollowUpDeviationComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: DeviationListComponent,
            resolve: {
              client: ClientResolver,
              //deviationlist: FollowupDeviationListResolver,
              //business: CompanyNameResolver,
              user: EmployeeContactUserResolver,
              topic: RiskAnalysisTopicCachedResolver,
              caseType: FollowupCaseTypeResolver,
              deviationByUser: DeviationsByUserResolver,
              department: AllDepartmentCachedResolver,
              deviationuser: DeviationUserResolver,
              departments: AllDepartmentResolver
            },
            canActivate: [AuthGuard]
          },
          {
            path: 'new',
            component: AddDeviationComponent,
            data: {
              parent: 'FOLLOWUP'
            },
            resolve: {
              topic: RiskAnalysisTopicCachedResolver,
              caseType: FollowupCaseTypeResolver,
              department: AllDepartmentCachedResolver,
              doclist: EmployeeDocResolver,
              user: EmployeeContactUserResolver,
              moduleDropdown: ModuleObjectDropdownResolver
            },
            canActivate: [AuthGuard]
          },
          {
            path: 'new-portal-deviation',
            component: AddDeviationComponent,
            data: {
              parent: 'FOLLOWUP'
            },
            resolve: {
              topic: BusinessLevelTopicResolver,
              caseType: FollowupCaseTypeByBusinessIdResolver,
              department: DepartmentsByBusinessIdResolver,
              doclist: EmployeeDocResolver,
              user: DeviationUserResolver
            },
            canActivate: [AuthGuard]
          },
          {
            path: 'edit/:deviationId',
            component: EditDeviationComponent,
            resolve: {
              edit: DeviationEditResolver,
              topic: RiskAnalysisTopicCachedResolver,
              caseType: FollowupCaseTypeResolver,
              department: AllDepartmentCachedResolver,
              user: EmployeeContactUserResolver,
              adminDepartment: DepartmentForAdminResolver,
              businessUser: EmployeeContactsListResolver
            }
          },
          {
            path: 'edit-portal-deviation/:deviationId',
            component: EditDeviationComponent,
            resolve: {
              edit: DeviationEditResolver,
              topic: BusinessLevelTopicResolver,
              caseType: FollowupCaseTypeByBusinessIdResolver,
              department: DepartmentsByBusinessIdResolver,
              user: DeviationUserResolver,
              adminDepartment: DepartmentForAdminResolver,
              businessUser: EmployeeContactsListResolver
            }
          }
        ]
      },
      {
        path: 'risk-analysis',
        component: RiskAnalysisComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: RiskAnalysisListComponent,
            resolve: {
              detail: RiskAnalysisEditResolver,
              approvalNotices: ApprovalNoticesResolver,
              list: RiskAnalysisListResolver,
              departments: AllDepartmentResolver,
              adminlist: RiskAnalysisAdminResolver,
              topic: RiskAnalysisTopicCachedResolver,
              business: CompanyNameResolver,
              Risklist: RiskListResolver,
              category: RiskAnalysisCategoryResolver
            }
          },
          {
            path: 'newrisk',
            component: NewRiskAnalysisComponent,
            resolve: {
              department: DepartmentCachedListResolver,
              topic: RiskAnalysisTopicCachedResolver,
              user: EmployeeContactUserResolver,
              category: RiskAnalysisCategoryResolver,
              business: CompanyNameResolver
            }
          },
          {
            path: 'edit-risk/:rid',
            component: NewRiskAnalysisComponent,
            resolve: {
              detail: RiskAnalysisEditResolver,
              department: DepartmentCachedListResolver,
              topic: RiskAnalysisTopicCachedResolver,
              user: EmployeeContactUserResolver,
              log: RiskAnalysisLogResolver,
              adminTopic: RiskAnalysisTopicForAdminResolver,
              adminDepartment: FollowupDepartmentForAdminResolver,
              usersAdmin: UserForAdminResolver,
              category: RiskAnalysisCategoryResolver,
              business: CompanyNameResolver
            }
          },
          {
            path: 'riskportal',
            component: NewRiskPortalComponent,
            resolve: {
              business: BusinessCacheResolver
            }
          }
        ]
      },
      {
        path: 'risk-analysis',
        component: RiskAnalysisComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: RiskAnalysisListComponent,
            resolve: {
              detail: RiskAnalysisEditResolver,
              list: RiskAnalysisListResolver,
              departments: AllDepartmentResolver,
              approvalNotices: ApprovalNoticesResolver,
              business: CompanyNameResolver,
              Risklist: RiskListResolver,
              category: RiskAnalysisCategoryResolver
            }
          },
          {
            path: 'newrisk',
            component: NewRiskAnalysisComponent,
            resolve: {
              department: DepartmentCachedListResolver,
              topic: RiskAnalysisTopicCachedResolver,
              user: ResponsibleForExecutionResolver,
              business: CompanyNameResolver
            }
          },
          {
            path: 'edit-risk/:rid',
            component: NewRiskAnalysisComponent,
            resolve: {
              detail: RiskAnalysisEditResolver,
              department: DepartmentCachedListResolver,
              topic: RiskAnalysisTopicCachedResolver,
              user: ResponsibleForExecutionResolver,
              treeData: ArchiveTreeDataResolver,
              business: CompanyNameResolver
            }
          }
        ]
      },
      {
        path: 'sjaform',
        component: SjaFormComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'list',
            component: SjaListComponent,
            canActivate: [AuthGuard],
            resolve: {
              business: CompanyNameResolver,
              list: SJAFormListResolver
            }
          },
          {
            path: 'new',
            component: SjaUserformComponent,
            canActivate: [AuthGuard],
            resolve: {
              sjaTitleList: SJATitleListResolver
            }
          },
          {
            path: 'edit/:Id',
            component: SjaUserformComponent,
            canActivate: [AuthGuard],
            resolve: {
              sjaform: SJAFormResolver,
              sjaTitleList: SJATitleListResolver
            }
          }
        ]
      }
    ]
  }
];
